export const VerificationCaisses = {
    path: '/verification_caisses',
    name: 'verification_caisses',
    component: () => import('@/views/Impression/VerificationCaisses/VerificationCaissePage.vue'),
}